import React, { useState } from 'react';

import { Box, Grid, Type, Btn, FieldSelect } from '@saladbob/sassafras'


function SwapTeam ({ teamKey, team1, team2, game, court, onSwap }) {
    const [teams] = useState(court.teams.map((team) => {
        return {
            value: team.id,
            label: team.name,
        }
    }));

    const [teamId, setTeamId] = useState(teamKey === 'team1' ? (team1 ? team1.id : '') : (team2 ? team2.id : ''));

    return (
        <Box>
            <Grid columns="1fr min-content" columnGap="md">
                <FieldSelect
                    name="team"
                    options={[
                        ...teams,
                        { value: '', label: 'Remove' },
                    ]}
                    value={teamId}
                    onChange={changeTeam}
                    controlled
                />
                <Btn onClick={swapTeam}>
                    <Type nowrap>Swap Team</Type>
                </Btn>
            </Grid>
        </Box>
    );

    function changeTeam (e) {
        setTeamId(e.target.value);
    }

    async function swapTeam (e) {
        const data = {
            depth: 0,
        };
        data[teamKey] = teamId || null;

        const team = await fetch(`${process.env.NEXT_PUBLIC_API_URL}/game/${game.id}`, {
            method: 'PATCH',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data),
        }).then((res) => res.json());

        if (typeof onSwap === 'function') {
            onSwap(team.doc[teamKey], teamKey);
        }
    }
}

export default SwapTeam;